import { FormControl, FormHelperText, Input, InputLabel } from '@mui/material'
import { t } from 'i18next'
import Joi from 'joi'
import { useEffect, useState } from 'react'

import useFieldValidation from '../../../helpers/fieldValidation.js'

export const schema = Joi.object({
  name: Joi.string().required(),
  maxDevicesCount: Joi.number().integer().positive().required(),
  maxOrganizationsCount: Joi.number().integer().positive().required(),
  maxCallsPerMonthCount: Joi.number().integer().positive().required(),
  dataRetentionPolicyInDays: Joi.number().integer().positive().required()
})

const OrganizationProfileForm = ({ profile, onChange = () => {} }) => {
  const [validation, setValidation] = useState({ isValid: false })
  const [profileData, setProfileData] = useState({
    name: '',
    maxDevicesCount: 0,
    maxOrganizationsCount: 0,
    maxCallsPerMonthCount: 0,
    dataRetentionPolicyInDays: 0
  })

  useEffect(() => {
    profile 
      ? setProfileData({
        name: profile.name || '',
        maxDevicesCount: profile.maxDevicesCount || 0,
        maxOrganizationsCount: profile.maxOrganizationsCount || 0,
        maxCallsPerMonthCount: profile.maxCallsPerMonthCount || 0,
        dataRetentionPolicyInDays: profile.dataRetentionPolicyInDays || 0
      })
      : setProfileData({
        name: '',
        maxDevicesCount: 0,
        maxOrganizationsCount: 0,
        maxCallsPerMonthCount: 0,
        dataRetentionPolicyInDays: 0
      })
  }, [profile])

  useEffect(() => {
    const newValidation = useFieldValidation(profileData, schema)
    setValidation(newValidation)

    onChange({
      data: profileData,
      validation: newValidation
    })
  }, [profileData])

  const handleNameChange = (event) => {
    const value = event.target.value
    setProfileData({
      ...profileData,
      name: value
    })
  }

  const handleMaxDevicesChange = (event) => {
    const value = event.target.value
    setProfileData({
      ...profileData,
      maxDevicesCount: parseInt(value)
    })
  }

  const handleMaxOrganizationsChange = (event) => {
    const value = event.target.value
    setProfileData({
      ...profileData,
      maxOrganizationsCount: parseInt(value)
    })
  }

  const handleMaxCallsChange = (event) => {
    const value = event.target.value
    setProfileData({
      ...profileData,
      maxCallsPerMonthCount: parseInt(value)
    })
  }

  const handleDataRetentionChange = (event) => {
    const value = event.target.value
    setProfileData({
      ...profileData,
      dataRetentionPolicyInDays: parseInt(value)
    })
  }

  return (
    <>
      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}>
        <InputLabel htmlFor="profile-name">{t('organizationProfiles.name')}</InputLabel>
        <Input
          id="profile-name"
          name="name"
          value={profileData.name}
          onChange={handleNameChange}
        />
        <FormHelperText error={!!validation?.messages?.name}>
          {validation?.messages?.name?.join(', ')}
        </FormHelperText>
      </FormControl>

      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}>
        <InputLabel htmlFor="max-devices">{t('organizationProfiles.maxDevices')}</InputLabel>
        <Input
          id="max-devices"
          name="maxDevicesCount"
          type="number"
          value={profileData.maxDevicesCount}
          onChange={handleMaxDevicesChange}
        />
        <FormHelperText error={!!validation?.messages?.maxDevicesCount}>
          {validation?.messages?.maxDevicesCount?.join(', ')}
        </FormHelperText>
      </FormControl>

      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}>
        <InputLabel htmlFor="max-organizations">{t('organizationProfiles.maxOrganizations')}</InputLabel>
        <Input
          id="max-organizations"
          name="maxOrganizationsCount"
          type="number"
          value={profileData.maxOrganizationsCount}
          onChange={handleMaxOrganizationsChange}
        />
        <FormHelperText error={!!validation?.messages?.maxOrganizationsCount}>
          {validation?.messages?.maxOrganizationsCount?.join(', ')}
        </FormHelperText>
      </FormControl>

      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}>
        <InputLabel htmlFor="max-calls">{t('organizationProfiles.maxCalls')}</InputLabel>
        <Input
          id="max-calls"
          name="maxCallsPerMonthCount"
          type="number"
          value={profileData.maxCallsPerMonthCount}
          onChange={handleMaxCallsChange}
        />
        <FormHelperText error={!!validation?.messages?.maxCallsPerMonthCount}>
          {validation?.messages?.maxCallsPerMonthCount?.join(', ')}
        </FormHelperText>
      </FormControl>

      <FormControl
        fullWidth
        sx={{ marginBottom: 3 }}>
        <InputLabel htmlFor="data-retention">{t('organizationProfiles.dataRetention')}</InputLabel>
        <Input
          id="data-retention"
          name="dataRetentionPolicyInDays"
          type="number"
          value={profileData.dataRetentionPolicyInDays}
          onChange={handleDataRetentionChange}
        />
        <FormHelperText error={!!validation?.messages?.dataRetentionPolicyInDays}>
          {validation?.messages?.dataRetentionPolicyInDays?.join(', ')}
        </FormHelperText>
      </FormControl>
    </>
  )
}

export default OrganizationProfileForm
